export interface FontFamilyOption {
  label: string;
  value: string;
}

export interface FontColorOption {
  label: string;
  value: string;
}

export const FONT_FAMILY_OPTIONS: FontFamilyOption[] = [
  { label: 'Default', value: '' },
  {
    label: 'Sans (System)',
    value: 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
  },
  { label: 'Inter', value: "'Inter', 'Segoe UI', Roboto, Arial, sans-serif" },
  {
    label: 'Poppins',
    value: "'Poppins', 'Segoe UI', Roboto, Arial, sans-serif",
  },
  { label: 'Montserrat', value: "'Montserrat', Arial, sans-serif" },
  { label: 'Lato', value: "'Lato', Arial, sans-serif" },
  { label: 'Open Sans', value: "'Open Sans', Arial, sans-serif" },
  { label: 'Nunito', value: "'Nunito', 'Segoe UI', Arial, sans-serif" },
  {
    label: 'Playfair Display',
    value: "'Playfair Display', Georgia, 'Times New Roman', serif",
  },
  { label: 'Merriweather', value: "'Merriweather', Georgia, serif" },
  { label: 'Georgia', value: "Georgia, 'Times New Roman', Times, serif" },
  { label: 'Trebuchet', value: "'Trebuchet MS', 'Segoe UI', sans-serif" },
  { label: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
  { label: 'Tahoma', value: 'Tahoma, Geneva, sans-serif' },
  { label: 'Courier New', value: "'Courier New', Courier, monospace" },
  {
    label: 'Monaco',
    value: "Monaco, Menlo, Consolas, 'Courier New', monospace",
  },
];

export const FONT_COLOR_OPTIONS: FontColorOption[] = [
  { label: 'Default', value: '' },
  { label: 'Black', value: '#000000' },
  { label: 'Charcoal', value: '#333333' },
  { label: 'Slate', value: '#475569' },
  { label: 'Gray', value: '#6b7280' },
  { label: 'White', value: '#ffffff' },
  { label: 'Red', value: '#dc2626' },
  { label: 'Orange', value: '#ea580c' },
  { label: 'Amber', value: '#d97706' },
  { label: 'Yellow', value: '#ca8a04' },
  { label: 'Green', value: '#16a34a' },
  { label: 'Teal', value: '#0d9488' },
  { label: 'Cyan', value: '#0891b2' },
  { label: 'Blue', value: '#2563eb' },
  { label: 'Indigo', value: '#4f46e5' },
  { label: 'Purple', value: '#9333ea' },
  { label: 'Pink', value: '#db2777' },
  { label: 'Rose', value: '#e11d48' },
];
